"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createAppointmentWaitlistMachine = void 0;
const xstate_1 = require("xstate");
const getInitialContext_1 = __importDefault(require("./getInitialContext"));
const States_1 = require("../lib/constants/States");
const actions_main_1 = __importStar(require("./machines/actions.main"));
const Events_1 = require("../lib/constants/Events");
const actions_main_2 = require("../../ManageAppointment/stateMachine/machines/actions.main");
const createAppointmentWaitlistMachine = (initialContext = (0, getInitialContext_1.default)()) => {
    return machine(initialContext, {
        actions: actions_main_1.default,
        guards: {},
        services: {}
    });
};
exports.createAppointmentWaitlistMachine = createAppointmentWaitlistMachine;
const machine = (initialContext = (0, getInitialContext_1.default)(), options = {}) => (0, xstate_1.createMachine)({
    id: 'appointmentWaitlist',
    initial: States_1.states.fetchingWaitlist,
    context: Object.assign(Object.assign({}, initialContext), { dateResponse: undefined }),
    states: {
        [States_1.states.fetchingWaitlist]: {
            entry: actions_main_1.setLoadingMachine,
            on: {
                [Events_1.LOADING_DONE]: {
                    actions: [actions_main_1.setLoadingMachineData, actions_main_1.setAppointmentQuery],
                    target: States_1.states.loadingDone
                },
                [Events_1.LOADING_ERROR]: {
                    target: States_1.states.error
                }
            }
        },
        [States_1.states.loadingDone]: {
            always: {
                target: States_1.states.confirmDob
            }
        },
        [States_1.states.confirmDob]: {
            entry: actions_main_1.setDobConfirmationMachine,
            on: {
                [Events_1.DATE_VALIDATED]: {
                    actions: [actions_main_1.setValidatedDateOfBirth],
                    target: States_1.states.apptTime
                }
            }
        },
        [States_1.states.apptTime]: {
            entry: actions_main_2.setApptTimeMachine
        },
        [States_1.states.error]: {
            type: 'final'
        }
    }
}, options);
//# sourceMappingURL=main.js.map